
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("73LWR", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $c6bd165760bf1280$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Korean
var $c6bd165760bf1280$export$2e2bcd8739ae039 = {
    'fabric.linkPicker.button.cancel': "\uCDE8\uC18C",
    'fabric.linkPicker.button.insert': "\uC0BD\uC785",
    'fabric.linkPicker.button.save': "\uC800\uC7A5",
    'fabric.linkPicker.clearLink': "\uC9C0\uC6B0\uAE30",
    'fabric.linkPicker.clearLinkText': "\uD14D\uC2A4\uD2B8 \uC9C0\uC6B0\uAE30",
    'fabric.linkPicker.hyperlink.searchLinkResults': "{count, plural, =0 {\uACB0\uACFC\uB97C \uCC3E\uC744 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4} other {{count,number}\uAC1C\uC758 \uACB0\uACFC\uB97C \uCC3E\uC558\uC2B5\uB2C8\uB2E4}}",
    'fabric.linkPicker.linkAriaLabel': "\uD544\uB4DC\uC5D0 \uB9C1\uD06C\uB97C \uC785\uB825\uD558\uAC70\uB098 \uBD99\uC5EC\uB123\uC73C\uC138\uC694",
    'fabric.linkPicker.linkHelperTextAriaLabel': "\uB9C1\uD06C \uD45C\uC2DC \uB3C4\uC6B0\uBBF8 \uD14D\uC2A4\uD2B8",
    'fabric.linkPicker.linkHelperTextLabel': "\uC774 \uB9C1\uD06C\uC5D0 \uC81C\uBAA9 \uB610\uB294 \uC124\uBA85\uC744 \uC785\uB825\uD558\uC138\uC694",
    'fabric.linkPicker.linkInvalid': "\uC720\uD6A8\uD55C URL\uC744 \uC785\uB825\uD558\uC138\uC694.",
    'fabric.linkPicker.linkLabel': "\uB9C1\uD06C",
    'fabric.linkPicker.linkPlaceholder': "\uB9C1\uD06C\uB97C \uBD99\uC5EC\uB123\uC73C\uC138\uC694",
    'fabric.linkPicker.linkTextAriaLabel': "\uB9C1\uD06C \uD45C\uC2DC \uD14D\uC2A4\uD2B8",
    'fabric.linkPicker.linkTextLabel': "\uD45C\uC2DC \uD14D\uC2A4\uD2B8(\uC120\uD0DD \uC0AC\uD56D)",
    'fabric.linkPicker.linkTextPlaceholder': "\uD45C\uC2DC\uD560 \uD14D\uC2A4\uD2B8",
    'fabric.linkPicker.listTitle.recentlyViewed': "\uCD5C\uADFC\uC5D0 \uBCF8 \uD56D\uBAA9",
    'fabric.linkPicker.listTitle.results': "\uACB0\uACFC",
    'fabric.linkPicker.noEmbed': "\uC774 \uB9C1\uD06C\uC5D0\uB294 \uD3EC\uD568 \uBCF4\uAE30\uAC00 \uC9C0\uC6D0\uB418\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4. <a>\uC77C\uBD80 \uC2A4\uB9C8\uD2B8 \uB9C1\uD06C\uAC00 \uCF58\uD150\uCE20\uB97C \uD45C\uC2DC\uD558\uC9C0 \uC54A\uB294 \uC774\uC720\uC5D0 \uB300\uD574 \uC790\uC138\uD788 \uC54C\uC544\uBCF4\uC138\uC694.</a>",
    'fabric.linkPicker.search.error.description': "\uD398\uC774\uC9C0\uB97C \uC0C8\uB85C \uACE0\uCE58\uAC70\uB098 \uBB38\uC81C\uAC00 \uACC4\uC18D \uBC1C\uC0DD\uD558\uB294 \uACBD\uC6B0 <a>Atlassian \uACE0\uAC1D \uC9C0\uC6D0\uD300</a>\uC5D0 \uBB38\uC758\uD558\uC138\uC694.",
    'fabric.linkPicker.search.error.heading': "\uB370\uC774\uD130\uB97C \uB85C\uB4DC\uD558\uB294 \uB3D9\uC548 \uBB38\uC81C\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4.",
    'fabric.linkPicker.search.error.retry': "\uC0C8\uB85C \uACE0\uCE68",
    'fabric.linkPicker.search.linkAriaLabel': "\uD544\uB4DC\uC5D0 \uC785\uB825\uD560 \uB54C \uC81C\uC548 \uC0AC\uD56D\uC774 \uC544\uB798\uC5D0 \uD45C\uC2DC\uB429\uB2C8\uB2E4",
    'fabric.linkPicker.search.linkLabel': "\uB9C1\uD06C\uB97C \uAC80\uC0C9\uD558\uAC70\uB098 \uBD99\uC5EC\uB123\uC73C\uC138\uC694",
    'fabric.linkPicker.search.linkPlaceholder': "\uCD5C\uADFC \uB9C1\uD06C\uB97C \uCC3E\uAC70\uB098 \uC0C8 \uB9C1\uD06C\uB97C \uBD99\uC5EC\uB123\uC73C\uC138\uC694",
    'fabric.linkPicker.search.noResults.description': "\uB2E4\uB978 \uAC80\uC0C9\uC5B4\uB85C \uB2E4\uC2DC \uC2DC\uB3C4\uD558\uC138\uC694.",
    'fabric.linkPicker.search.noResults.heading': "\uAC80\uC0C9 \uC870\uAC74\uACFC \uC77C\uCE58\uD558\uB294 \uD56D\uBAA9\uC744 \uCC3E\uC744 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.",
    'fabric.linkPicker.status.submitting': "\uC81C\uCD9C \uC911",
    'fabric.linkPicker.time.message.updated': "{time}\uC5D0 \uC5C5\uB370\uC774\uD2B8",
    'fabric.linkPicker.time.message.viewed': "{time}\uC5D0 \uD655\uC778",
    'fabric.linkPicker.unhandledError.description': "\uD398\uC774\uC9C0\uB97C \uB2E4\uC2DC \uB85C\uB4DC\uD574 \uBCF4\uC138\uC694.",
    'fabric.linkPicker.unhandledError.heading': "\uBB38\uC81C\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4."
};

});


//# sourceMappingURL=ko.cd224552.js.map
